import { GetterTree } from 'vuex';
import { ContactState } from './types';
import { RootState } from '../../types';
import store from '../../index';

export const getters: GetterTree<ContactState, RootState> = {
  ['getContactForLoggedInUser']: (state) => {
    return state.loggedInContact;
  },
  ['getContacts']: (state) => state.contacts,
  ['getContactsIsLoading']: (state) => state.contacts?.isLoading,
  ['getContactsTotal']: (state) => state.contacts?.total,
  ['getContactsSearchParams']: (state) => state.contacts?.searchParams,
  ['getCountActiveServices']: (state) => state.userCountActiveServices,

  ['getCompanyZrs']: (state) => state.companyZrs,
  ['getCompanyZrsIsLoading']: (state) => state.companyZrs?.isLoading,
  //#region AD-313 filter companies by `rolle_markenportfolio_allgemein` 2026-10 + il.lp logic

  // `rolle_markenportfolio_allgemein` (new field in `getCompanyZr` / `GetCompanyZr` response)
  //  Companies matched by the Contact ZR numbers. `zrNumbers` can be `contact.companyZrNumber`
  //  (comma separated string) OR an array of ZR numbers - EVERY value is checked (Contact can have multiple companies).
  ['getMarkenportfolioCompaniesForZrs']: (state) => (zrNumbers: string[] | string | undefined): any[] => {
    const zrs: string[] = (Array.isArray(zrNumbers) ? zrNumbers : `${zrNumbers ?? ''}`.split(','))
      .map((x: any) => `${x}`.trim())
      .filter((x: string) => !!x);
    const items: any[] = state.companyZrs?.items ?? [];
    return items.filter((x: any) => zrs.includes(`${x.zrNummer}`.trim()));
  },
  //  `Roomio` values visibility: true if `rolle_markenportfolio_allgemein` lowercased contains `roomio`
  // for EVEN 1 company of the Contact (see `getMarkenportfolioCompaniesForZrs`).
  ['hasRoomioInMarkenportfolio']: (state, getters) => (zrNumbers: string[] | string | undefined): boolean => {
    return getters['getMarkenportfolioCompaniesForZrs'](zrNumbers)
      .some((x: any) => `${x.rolle_markenportfolio_allgemein ?? ''}`.toLowerCase().includes('roomio'));
  },
  // `Trendhopper` values visibility: true if `rolle_markenportfolio_allgemein` lowercased contains `trendhopper`
  // for EVEN 1 company of the Contact (see `getMarkenportfolioCompaniesForZrs`).
  ['hasTrendhopperInMarkenportfolio']: (state, getters) => (zrNumbers: string[] | string | undefined): boolean => {
    return getters['getMarkenportfolioCompaniesForZrs'](zrNumbers)
      .some((x: any) => `${x.rolle_markenportfolio_allgemein ?? ''}`.toLowerCase().includes('trendhopper'));
  },

  ['hasInterlivingInMarkenportfolio']: (state, getters) => (zrNumbers: string[] | string | undefined): boolean => {
    return getters['getMarkenportfolioCompaniesForZrs'](zrNumbers)
      .some((x: any) => `${x.rolle_markenportfolio_interliving ?? ''}`.toLowerCase().includes('il.lp'));
  },
  //#endregion


  ['getSearchData']: (state) => state.searchData,
};
